var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-msg"},[_c('img',{attrs:{"src":require("@/assets/base-error-img.png"),"alt":""}}),_vm._v("\n  "+_vm._s(_vm.errorMsg)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }